<template>
    <div class="skeleton-wrapper" :class="{ inline: inline }">
        <div v-for="i in amount" :key="i" class="skeleton" :style="`width: ${width()}`" />
    </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
export default defineComponent({
    props: {
        amount: { type: Number, default: 1 },
        minWidth: { type: Number, default: 15 },
        maxWidth: { type: Number, default: 100 },
        inline: { type: Boolean },
    },
    methods: {
        width() {
            const width = this.minWidth + Math.ceil(Math.random() * (this.maxWidth - this.minWidth));
            return `${width}%`;
        },
    },
});
</script>
<style lang="scss">
.skeleton-wrapper {
    &.inline {
        display: inline-block;
    }

    .skeleton {
        height: 1em;
        border-radius: 0.5rem;
        background: #dee2e6;
        margin: 0.25rem;
        animation: skeleton 1.5s ease-in-out infinite;
        animation-fill-mode: forwards;
    }
}

@keyframes skeleton {
    0% {
        opacity: 0.25;
    }
    50% {
        opacity: 1;
    }
    100% {
        opacity: 0.25;
    }
}
</style>
